<section class="ld" id="leadership" #root aria-labelledby="ld-title">
  <div class="ld__bg" aria-hidden="true">
    <span class="ld__blob ld__blob--pink"></span>
    <span class="ld__blob ld__blob--violet"></span>

    <svg class="ld__orbit" viewBox="0 0 400 400" fill="none">
      <circle cx="200" cy="200" r="180" stroke="url(#ldOrb)" stroke-width="1" />
      <circle class="ld__orbit-dot" cx="200" cy="20" r="5" fill="#ff4fa3" />
      <defs>
        <linearGradient id="ldOrb" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#ff4fa3" stop-opacity=".34" />
          <stop offset="100%" stop-color="#a855f7" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <span class="ld__motes">
      <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
    </span>
  </div>

  <div class="container ld__inner">
    <header class="ld__head" #head>
      <span class="ld__badge">
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="m12 2.6 2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.7l-5.9 3.1 1.2-6.6L2.5 9.6l6.6-.9z" />
        </svg>
        OUR LEADERSHIP
      </span>

      <h2 class="ld__title" id="ld-title">
        Meet Our <span class="ld__title-grad">Leadership Team</span>
      </h2>

      <span class="ld__divider" aria-hidden="true"><i></i><em></em><i></i></span>

      <p class="ld__lede">
        Passionate professionals driving innovation and excellence.
      </p>
    </header>

    <!-- ============================================================
         CAROUSEL — cards are positioned by their offset from centre,
         so the loop is endless without cloning any nodes.
         ============================================================ -->
    <div class="ld__stage" #stage>
      <button
        type="button"
        class="ld__nav ld__nav--prev"
        (click)="go(-1)"
        aria-label="Previous leader"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <path d="M15 6l-6 6 6 6" />
        </svg>
      </button>

      <div class="ld__track">
        <article
          class="ld__card"
          *ngFor="let l of leaders; let i = index; trackBy: trackLeader"
          [class.is-active]="offset(i) === 0"
          [class.is-off]="!isOnStage(i)"
          [style.--o]="offset(i)"
          [style.zIndex]="10 - (offset(i) < 0 ? -offset(i) : offset(i))"
          [attr.aria-hidden]="offset(i) === 0 ? null : 'true'"
          (click)="select(i)"
        >
          <span class="ld__crown" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="m3 7 4 4 5-6 5 6 4-4-2 12H5z" />
            </svg>
          </span>

          <span class="ld__photo">
            <img
              [src]="l.img"
              [alt]="l.tittle + ' — ' + l.position"
              loading="lazy"
              decoding="async"
            />
            <span class="ld__photo-wash" aria-hidden="true"></span>
          </span>

          <span class="ld__meta">
            <b class="ld__name">{{ l.tittle }}</b>
            <u class="ld__role">{{ l.position }}</u>

            <span class="ld__social">
              <a
                class="ld__soc"
                [href]="l.linkedin || 'https://www.linkedin.com/company/resiliencesoft'"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="'LinkedIn profile of ' + l.tittle"
                [attr.tabindex]="offset(i) === 0 ? null : -1"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3zM9 9h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.4c0-1.29-.02-2.95-1.8-2.95-1.8 0-2.07 1.4-2.07 2.85V21H9z" />
                </svg>
              </a>

              <a
                class="ld__soc"
                [href]="'mailto:' + (l.email || mailTo)"
                [attr.aria-label]="'Email ' + l.tittle"
                [attr.tabindex]="offset(i) === 0 ? null : -1"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
                  <path d="m3 7 9 6 9-6" />
                </svg>
              </a>
            </span>
          </span>

          <span class="ld__accent" aria-hidden="true"></span>
          <span class="ld__edge" aria-hidden="true"></span>
        </article>
      </div>

      <button
        type="button"
        class="ld__nav ld__nav--next"
        (click)="go(1)"
        aria-label="Next leader"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <path d="m9 6 6 6-6 6" />
        </svg>
      </button>
    </div>

    <div class="ld__dots" role="tablist" aria-label="Choose a leader">
      <button
        type="button"
        role="tab"
        *ngFor="let l of leaders; let i = index; trackBy: trackLeader"
        class="ld__dot"
        [class.is-on]="offset(i) === 0"
        [attr.aria-selected]="offset(i) === 0"
        [attr.aria-label]="l.tittle"
        (click)="select(i)"
      ></button>
    </div>
  </div>
</section>
